/**
 * Toggles body.is-scrolling class during scroll (debounced).
 * Used by header CSS to hide nav dropdowns while the user is scrolling.
 */
(function () {
  let scrollTimeout;

  window.addEventListener(
    'scroll',
    () => {
      document.body.classList.add('is-scrolling');

      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        document.body.classList.remove('is-scrolling');
      }, 150);
    },
    { passive: true },
  );
})();
